import script from "./myMainPageNew.vue?vue&type=script&setup=true&lang=js"
export * from "./myMainPageNew.vue?vue&type=script&setup=true&lang=js"

import "./myMainPageNew.vue?vue&type=style&index=0&id=a76ebb9a&scoped=true&lang=scss"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a76ebb9a"]])

export default __exports__